._variablesHolder_gugo7_1 {
  container-type: inline-size;
  container-name: chat;
  height: 100%;
  width: 100%;
  --chat-message-ai-bg-color: #fff;
  --chat-message-user-bg-color: transparent;
  --chat-message-drop-shadow: unset;
  --text-color: inherit;
  --asisstant-image-url: url('../assets/media/assistant.svg') no-repeat;
  --chat-input-button-bg-color: linear-gradient(266.44deg, #5FF2CF -28.21%, #0E53FD 100%);
  --chat-input-button-bg-color-disabled: inherit;
  --chat-input-bg: linear-gradient(white, white) padding-box,
    linear-gradient(266.44deg, #5FF2CF -28.21%, #0E53FD 100%) border-box;
  --chat-input-bg-disabled: linear-gradient(white, white) padding-box,
    linear-gradient(266.44deg, #B3B4BD -28.21%, #B3B4BD 100%) border-box;
  --chat-input-bg-focus: linear-gradient(white, white) padding-box,
    linear-gradient(52.63deg, #6F56F9 38.28%, #116DFF 81.81%, #0DB8C4 100%) border-box;
  --chat-input-icon-fill: white;
  --suggestion-tag-color-hover: white;
  --input-caret: #615BFB;
  --text-font-size-slim: 14px;
  --text-line-height-slim: 18px;
  --color-d-02: rgba(37, 37, 42, 1);
  --color-d-03: rgba(53, 54, 57, 1);
  --color-d-05: rgba(156, 156, 162, 1);
  --color-b-50: rgba(231, 240, 255, 1);
  --color-b-20: rgba(89, 153, 255, 1); }
  ._variablesHolder_gugo7_1[data-theme="chat-theme-light"], ._variablesHolder_gugo7_1[data-theme="chat-theme-dark"] {
    --chat-message-drop-shadow: 0px 10px 24px 0px rgba(0, 6, 36, 0.08); }
  ._variablesHolder_gugo7_1[data-theme="chat-theme-light"] {
    --chat-input-bg: linear-gradient(#FFF, #FFF) padding-box,
      linear-gradient(60deg, #A3C7FF 0%, #A4C7FF 65%, #7DD8AE 96%) border-box;
    --chat-input-bg-focus: linear-gradient(#FFF, #FFF) padding-box,
      linear-gradient(60deg, #A3C7FF 0%, #A4C7FF 65%, #7DD8AE 96%) border-box;
    --chat-message-user-bg-color: linear-gradient(90deg, #F5F8FF 0%, #FAFCFF 30%, #F5F8FF 100%);
    --chat-message-ai-bg-color: #FFF;
    --chat-input-button-bg-color: linear-gradient(60deg, #0021FF 0%, #116DFF 50%, #5FF2AE 100%); }
  ._variablesHolder_gugo7_1[data-theme="chat-theme-dark"] {
    --text-color: #FFF;
    --chat-message-user-bg-color: rgba(81, 82, 84, 1);
    --chat-message-ai-bg-color: rgba(53, 54, 57, 1);
    --asisstant-image-url: url('../assets/media/assistant_dark.svg') no-repeat;
    --chat-input-bg: linear-gradient(#000000, #000000) padding-box,
      linear-gradient(62.09deg, #6C939F 15.65%, #758BA0 39.02%, #577B7C 63.68%) border-box;
    --chat-input-bg-focus: linear-gradient(#000000, #000000) padding-box,
      linear-gradient(62.09deg, #6C939F 15.65%, #758BA0 39.02%, #577B7C 63.68%) border-box;
    --input-caret: #FFF;
    --chat-input-button-bg-color: linear-gradient(149.67deg, #FFFFFF 38.33%, #AEFF84 111.49%);
    --chat-input-icon-fill: #000;
    --chat-input-bg-disabled: linear-gradient(#000, #000) padding-box,
      #515254 border-box; }

._rootWrapper_gugo7_54 {
  height: 100%;
  width: 100%; }

._root_gugo7_54 {
  height: 100%;
  width: 100%;
  overflow-x: visible;
  box-sizing: border-box;
  position: relative; }
  [data-theme="chat-theme-original"] ._root_gugo7_54 {
    background: #fff; }
  ._root_gugo7_54 ._chatContent_gugo7_66 {
    max-height: calc(100% - 50px);
    overflow: auto;
    padding: 12px 12px 60px 12px; }
    [data-theme="chat-theme-dark"] ._root_gugo7_54 ._chatContent_gugo7_66,
    [data-theme="chat-theme-light"] ._root_gugo7_54 ._chatContent_gugo7_66 {
      padding: 18px 18px 60px 18px; }
  ._root_gugo7_54 ._space_gugo7_73 {
    flex-grow: 1; }
  ._root_gugo7_54 ._suggestions_gugo7_75 {
    height: 20px; }
  ._root_gugo7_54 ._inputWrapper_gugo7_77 {
    display: flex;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    margin: 12px;
    margin-top: 0; }
    [data-theme="chat-theme-dark"] ._root_gugo7_54 ._inputWrapper_gugo7_77,
    [data-theme="chat-theme-light"] ._root_gugo7_54 ._inputWrapper_gugo7_77 {
      margin: 18px;
      margin-top: 0; }

._tags_gugo7_89 {
  margin: 14px 12px 12px 12px; }
  [data-theme="chat-theme-dark"] ._tags_gugo7_89,
  [data-theme="chat-theme-light"] ._tags_gugo7_89 {
    margin: 14px 18px 12px 18px; }

._scrollDownButton_gugo7_95 {
  position: absolute;
  bottom: 70px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 2;
  transition: all 0.2s ease-in-out; }
  [data-theme="chat-theme-dark"] ._scrollDownButton_gugo7_95,
  [data-theme="chat-theme-light"] ._scrollDownButton_gugo7_95 {
    bottom: 90px; }

@container chat (max-width: 470px) {
  [data-theme="chat-theme-dark"] ._scrollDownButton_gugo7_95,
  [data-theme="chat-theme-light"] ._scrollDownButton_gugo7_95 {
    bottom: 80px; } }
  ._scrollDownButtonHidden_gugo7_110 {
    transform: translateX(-50%) translateY(50%);
    opacity: 0;
    pointer-events: none; }
